/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { connect } from 'react-redux';
import { Form as FormUi, Container, Button, Label, Modal, Dropdown, Grid } from 'semantic-ui-react';
import putAxios from '../../axiosComponent/put';
import cogoToast from 'cogo-toast'
import TyrePositionDropdown from '../vehicleType/tyrePositionDropdown'
import TyreSizeDropDown from '../vehicleType/tyreSizeDropdown';
import TyreTypeDropDown from '../vehicleType/tyreTypeDropdown';
import TyreStatusDropDown from '../vehicleType/tyreStatusDropdown';
import TyreModelDropDown from '../vehicleType/tyreModalDropdown';
import TyreMakeDropDown from '../vehicleType/tyreMakeDropdown';
import { getTyrePosition, getTyreSize, getTyreType, getTyreStatus, getTyreModal, getTyreMake } from './tyreActions'


const AddTyreInventory = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose, ...props }) => {

  const [tyrePositionData, setTyrePositionData] = useState([])
  const [tyreSizeData, setTyreSizeData] = useState([])
  const [tyreTypeData, setTyreTypeData] = useState([])
  const [tyreStatusData, setTyreStatusData] = useState([])
  const [tyreModelData, setTyreModelData] = useState([])
  const [tyreMakeData, setTyreMakeData] = useState([])

  useEffect(() => {
    let tyrePosition = getTyrePosition()
    tyrePosition.then((resp) => {
      setTyrePositionData(resp.resultSet)
    }).catch((err) => {
    })

    let tyreSize = getTyreSize()
    tyreSize.then((resp) => {
      setTyreSizeData(resp.resultSet)
    }).catch((err) => {
    })

    let tyreType = getTyreType()
    tyreType.then((resp) => {
      setTyreTypeData(resp.resultSet)
    }).catch((err) => {
    })

    let tyreStatus = getTyreStatus()
    tyreStatus.then((resp) => {
      setTyreStatusData(resp.resultSet)
    }).catch((err) => {
    })

    let tyreModal = getTyreModal()
    tyreModal.then((resp) => {
      setTyreModelData(resp.resultSet)
    }).catch((err) => {
    })

    let tyreMake = getTyreMake()
    tyreMake.then((resp) => {
      setTyreMakeData(resp.resultSet)
    }).catch((err) => {
    })
  }, [])


  let handleDelete = () => {
  }

  return (
    <>
      <Modal.Content>
        <Container>
          <div className="ui form mb-5">
            <Grid columns={2}>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Serial No *</label>
                <Fieldmik className={errors.serialNo ? 'border border-danger' : ''} name="serialNo" placeholder="Serial Number" />
                {touched.serialNo && errors.serialNo ? <Label size="w3-tiny w3-text-red p-bold-600" prompt pointing>{errors.serialNo}</Label> : ''}
              </Grid.Column>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Position</label>
                <FormUi.Field>
                  <Fieldmik component={TyrePositionDropdown} handleDelete={handleDelete} tyrePositionData={tyrePositionData} name={`tyrePositionId`} value={values.tyrePositionId} />
                  {touched.tyrePositionId && errors.tyrePositionId ? <Label size="mini" prompt pointing>{errors.tyrePositionId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
            <Grid columns={2}>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Thread Depth</label>
                <Fieldmik name={`threadDepth`} placeholder='Thread Depth' value={values.threadDepth} />
                {touched.threadDepth && errors.threadDepth ? <Label size="w3-tiny w3-text-red p-bold-600" prompt pointing>{errors.threadDepth}</Label> : ''}
              </Grid.Column>
              <Grid.Column width={8}>
                <FormUi.Field>
                  <label className="labelName p-bold-600">Size</label>
                  <Fieldmik component={TyreSizeDropDown} tyreSizeData={tyreSizeData} name={`tyreSizeId`} value={values.tyreSizeId} />
                  {touched.tyreSizeId && errors.tyreSizeId ? <Label size="mini" prompt pointing>{errors.tyreSizeId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
            <Grid columns={2}>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Type</label>
                <FormUi.Field>
                  <Fieldmik component={TyreTypeDropDown} tyreTypeData={tyreTypeData} name={`tyreTypeId`} value={values.tyreTypeId} />
                  {touched.tyreTypeId && errors.tyreTypeId ? <Label size="mini" prompt pointing>{errors.tyreTypeId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Status *</label>
                <FormUi.Field>
                  <Fieldmik className={errors.tyreStatusId ? 'border border-danger' : ''} component={TyreStatusDropDown} tyreStatusData={tyreStatusData} name={`tyreStatusId`} value={values.tyreStatusId} />
                  {touched.tyreStatusId && errors.tyreStatusId ? <Label size="mini w3-text-red p-bold-600" prompt pointing>{errors.tyreStatusId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
            <Grid columns={2}>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Model</label>
                <FormUi.Field>
                  <Fieldmik component={TyreModelDropDown} tyreModelData={tyreModelData} name={`tyreModelId`} value={values.tyreModelId} />
                  {touched.tyreModelId && errors.tyreModelId ? <Label size="mini" prompt pointing>{errors.tyreModelId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
              <Grid.Column width={8}>
                <label className="labelName p-bold-600">Make</label>
                <FormUi.Field>
                  <Fieldmik component={TyreMakeDropDown} tyreMakeData={tyreMakeData} name={`tyreMakeId`} value={values.tyreMakeId} />
                  {touched.tyreMakeId && errors.tyreMakeId ? <Label size="mini" prompt pointing>{errors.tyreMakeId}</Label> : ''}
                </FormUi.Field>
              </Grid.Column>
            </Grid>
          </div>
        </Container>
      </Modal.Content>
      <Modal.Actions>
        {isSubmitting ? 'Loading...' : ''}
        <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
        <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="tiny" primary>Submit</Button>
      </Modal.Actions>
    </>
  )
}

const FormikAddTyreInventory = withFormik({
  mapPropsToValues({ serialNo, tyrePositionId, tyreStatusId, tyreSizeId, tyreTypeId, tyreMakeId, tyreModelId, roleId, threadDepth }) {
    return {
      serialNo: serialNo || '',
      tyrePositionId: tyrePositionId || '',
      tyreStatusId: tyreStatusId || '',
      tyreSizeId: tyreSizeId || '',
      tyreTypeId: tyreTypeId || '',
      tyreMakeId: tyreMakeId || '',
      tyreModelId: tyreModelId || '',
      threadDepth: threadDepth || '',
      roleId: roleId || '',
    }
  },
  validationSchema: yup.object().shape({
    serialNo: yup.string().required('Serial No is mandatory'),
    tyrePositionId: yup.string(),
    tyreStatusId: yup.number().required('Status is madatory'),
    tyreSizeId: yup.number(),
    tyreTypeId: yup.number(),
    tyreMakeId: yup.number(),
    tyreModelId: yup.number(),
    threadDepth:yup.number()
  }),

  handleSubmit(values, { setErrors, setSubmitting, setSuccess }) {
    setSubmitting(true)
    let serialNo = values.serialNo
    let tyrePositionId = values.tyrePositionId
    let tyreStatusId = values.tyreStatusId
    let tyreSizeId = values.tyreSizeId
    let tyreTypeId = values.tyreTypeId
    let tyreMakeId = values.tyreMakeId
    let tyreModelId = values.tyreModelId
    let threadDepth = values.threadDepth

    putAxios({
      url: `masters/tyre`,
      createItems: {
        'serialNo': serialNo,
        'tyrePositionId': String(tyrePositionId),
        'tyreStatusId': tyreStatusId,
        'tyreSizeId': tyreSizeId,
        'tyreTypeId': tyreTypeId,
        'tyreMakeId': tyreMakeId,
        'tyreModelId': tyreModelId,
        'threadDepth': threadDepth

      },
    }).then
      ((data) => {
        if (data.data.status == 200) {
          cogoToast.success(data.data.message)
          setTimeout(() => {
            window.location.href = "/tyre-inventory"
          }, 1000);

          setSubmitting(false)
        } else if (data.data.status == 204) {
          setTimeout(() => {
            cogoToast.error(data.data.message)
          }, 500);
          setSubmitting(false)
        }
        else {
          alert(data.data.message)
          setSubmitting(false)
        }
      }
      )
  }
})(AddTyreInventory)

const mapStatetoProps = (state) => ({
  vehicleTypeData: state.getVehicleType.vehicleTypeList.resultSet,
  isLoading: state.getVehicleType.isLoading
})

export default connect(mapStatetoProps, { getTyrePosition })(FormikAddTyreInventory)
